/** Contract state views for the redesigned portfolio filter. */
export const PORTFOLIO_CONTRACT_STATE = {
	all: "all",
	archived: "archived",
} as const;

export type PortfolioContractStateKey =
	(typeof PORTFOLIO_CONTRACT_STATE)[keyof typeof PORTFOLIO_CONTRACT_STATE];
